// extracted by mini-css-extract-plugin
module.exports = {"submission-container":"style_submission-container__16zV-","title-input":"style_title-input__lXs6L"};